module.exports = __webpack_public_path__ + "static/media/AUXO-Vert-Light.3a44fbfe.png";